export default [
  {
    path: "",
    name: "reminder-list",
    component: () => import("@/view/pages/reminder/Reminders"),
  },
];
